export default __webpack_public_path__ + "static/media/founder.656ab013.jpg";